import { imageAPI } from '../api/requests/Logo/logoAPI';

export const imageHandler = {

  setStore(val = {}) {
    localStorage.setItem('imagesObj', JSON.stringify(val));
  },

  toArray(val = []) {
    return Array.isArray(val) ? val : [val];
  },

  async fetchAllImages() {
    try {
      const { data } = await imageAPI.getAllImages();

      const filterData = {};

      for (const key in data) {
        if (data[key]) {
          filterData[key] = this.toArray(data[key]);
        }
      }

      this.setStore(filterData);
    } catch (error) {}
  },

  getAll() {
    return JSON.parse(localStorage.getItem('imagesObj') ?? '{}');
  },

  get(key, index) {
    const images = this.getAll();

    if (!Object.hasOwn(images, key)) return null;

    const image = images[key];

    return index ? image.at(index) : image;
  },

  set(key, val = []) {
    const images = this.getAll();

    images[key] = this.toArray(val);
    this.setStore(images);
  },

  update(key, val = '', index = 0) {
    const images = this.getAll();

    if (!Object.hasOwn(images, key)) return;

    if (index < images[key]?.length) {
      images[key][index] = val;
    } else {
      images[key]?.push(val);
    }

    this.setStore(images);
  },

  add(key, val = '', index = -1) {
    const images = this.getAll();

    if (!Object.hasOwn(images, key)) {
      images[key] = [val];
      this.setStore(images);

      return;
    }

    if (index === -1) {
      images[key]?.push(val);
    } else {
      images[key].splice(index, 0, val);
    }

    this.setStore(images);
  },

  find(fn = _ => true) {
    const images = this.getAll();

    const res = [];

    for (const key in images)
      if (fn(key, images[key]))
        res.push(images[key]);

    return res;
  },

  remove(key, index = 0) {
    const images = this.getAll();

    if (!Object.hasOwn(images, key)) return;

    const image = images[key];

    if (image.length === 1)
      return this.delete(key);

    image.splice(index, 1);

    this.setStore(images);
  },

  delete(key) {
    const {
      [key]: _, ...images
    } = this.getAll();

    this.setStore(images);
  }

};
